import {FC} from 'react';

import {IDelayDocVars} from '../../components/ServiceRequests/service-request/utils';

import rksLogo from '../../assets/docLogo.svg';

interface IDelayDocTemplate {
  data: IDelayDocVars;
}

export const DelayDocTemplate: FC<IDelayDocTemplate> = (props) => {
  return (
    <div
      id="delay-doc"
      style={{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        position: 'relative',
        width: 'fit-content',
        boxSizing: 'border-box',
        margin: 'auto',
        fontSize: '28px',
      }}
    >
      <div style={{position: 'relative', width: 'fit-content', height: '2808px', padding: '20px 40px'}}>
        <header>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              width: '100%',
              borderBottom: '1px solid black',
              justifyContent: 'space-between',
              alignItems: 'center',
              paddingBottom: '2px',
              marginBottom: '2px',
            }}
          >
            <img src={rksLogo} style={{transform: 'scale(1.35)', paddingLeft: '30px'}} alt="" />
            <div style={{display: 'flex', flex: 0.95, flexDirection: 'column', fontSize: '26px'}}>
              <p style={{margin: 0, textWrap: 'wrap'}}>Гарантирующий поставщик ООО «РКС-энерго»</p>
              <p style={{margin: 0, textWrap: 'wrap'}}>
                <b>Юридический адрес:</b> ул. Жука, д.3, пом. 204, Шлиссельбург, Кировский район, Ленинградская область,
                Российская Федерация, 187320
              </p>
              <p style={{margin: 0, textWrap: 'wrap'}}>
                <b>Почтовый адрес:</b> 194044, г. Санкт-Петербург, Финляндский пр., д. 4 а, офисы 136-158.
                <br />
                Тел./факс: (812) 244-70-64. E-mail: office@rks-energo.ru
              </p>
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              borderTop: '1px solid black',
              marginBottom: '10px',
            }}
          >
            <div
              style={{
                display: 'flex',
                marginTop: '15px',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <h4
                style={{
                  fontSize: '28px',
                  margin: 0,
                  marginBottom: '2.5px',
                  display: 'inline-flex',
                  flexDirection: 'row',
                }}
              >
                <b style={{display: 'inline-flex', flexDirection: 'row', alignItems: 'center'}}>
                  Акт №&nbsp;&nbsp;&nbsp;
                  {props.data.idDelay ? (
                    <p style={{minWidth: '250px', textAlign: 'center', margin: 0, borderBottom: '1px solid black'}}>
                      {props.data.idDelay}
                    </p>
                  ) : (
                    <p style={{textAlign: 'center', margin: 0}}>{`________________________`}</p>
                  )}
                </b>
              </h4>
              <h4 style={{fontSize: '28px', margin: 0, display: 'inline-flex', flexDirection: 'row'}}>
                <b>недопуска к приборам учёта электрической энергии</b>
              </h4>
            </div>
          </div>
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
            <p>
              Время:&nbsp;&nbsp;&nbsp;«
              <span
                style={{width: '106px', display: 'inline-block', textAlign: 'center', borderBottom: '1px solid black'}}
              >
                {props.data.hours || ''}
              </span>
              »&nbsp;&nbsp;часов&nbsp;&nbsp;«
              <span
                style={{width: '106px', display: 'inline-block', textAlign: 'center', borderBottom: '1px solid black'}}
              >
                {props.data.minutes || ''}
              </span>
              »&nbsp;&nbsp;минут
            </p>
            <p>
              Дата&nbsp;&nbsp;&nbsp;&nbsp;«
              <span
                style={{width: '80px', display: 'inline-block', textAlign: 'center', borderBottom: '1px solid black'}}
              >
                {props.data.day || ''}
              </span>
              » &nbsp;&nbsp;
              <span
                style={{width: '124px', display: 'inline-block', textAlign: 'center', borderBottom: '1px solid black'}}
              >
                {props.data.month || ''}
              </span>
              &nbsp;20
              <span
                style={{width: '68px', display: 'inline-block', textAlign: 'center', borderBottom: '1px solid black'}}
              >
                {props.data.year || ''}
              </span>
              &nbsp;г.
            </p>
          </div>
        </header>
        <div>
          <div>
            <p>
              Составлен представителем гарантирующего поставщика ООО «ЭМС», действующим на основании доверенности
              №&nbsp;
              <span
                style={{width: '188px', display: 'inline-block', textAlign: 'center', borderBottom: '1px solid black'}}
              >
                147-1/2024
              </span>
              &nbsp;от&nbsp;«
              <span
                style={{width: '48px', display: 'inline-block', textAlign: 'center', borderBottom: '1px solid black'}}
              >
                16
              </span>
              »&nbsp;
              <span
                style={{width: '86px', display: 'inline-block', textAlign: 'center', borderBottom: '1px solid black'}}
              >
                мая
              </span>
              &nbsp;2024г.
            </p>
          </div>
          <div style={{display: 'flex', flexDirection: 'column'}}>
            <p style={{margin: 0, display: 'inline-flex', flexDirection: 'row', alignItems: 'center'}}>
              в лице:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span style={{margin: 0, width: '90%', borderBottom: '1px solid black', fontSize: '28px'}}>
                <b>Электромонтера - </b>
                {props.data.userFio}
              </span>
            </p>
            <p
              style={{
                margin: 0,
                fontSize: '28px',
                display: 'inline-flex',
                flexDirection: 'row',
                justifyContent: 'center',
              }}
            >
              <i>(должность, ФИО)</i>
            </p>
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginTop: '5px',
            alignItems: 'flex-end',
          }}
        >
          <p style={{margin: 0, display: 'inline-block', width: '145px', textWrap: 'wrap', fontSize: '24px'}}>
            в отношении <b>потребителя</b>
          </p>
          <p
            style={{
              margin: 0,
              display: 'inline-block',
              height: 'fit-content',
              flex: 0.45,
              borderBottom: '1px solid black',
              fontSize: '28px',
            }}
          >
            {props.data.customer}
          </p>
          <p style={{margin: 0, fontSize: '24px'}}>
            <b>лицевой счёт</b>
          </p>
          <p style={{margin: 0, flex: 0.45, borderBottom: '1px solid black', fontSize: '28px'}}>
            {props.data.idLicAccount}
          </p>
        </div>
        <div style={{display: 'flex', flexDirection: 'column', marginTop: '5px'}}>
          <p style={{display: 'inline-flex', flexDirection: 'row', gap: '10px'}}>
            по адресу:
            <span style={{margin: 0, display: 'inline-flex', flex: 0.45, justifyContent: 'space-between'}}>
              <b>нас. пункт</b>
              <span
                style={{margin: 0, flex: 0.8, borderBottom: '1px solid black', paddingLeft: '5px', fontSize: '28px'}}
              >
                {props.data.city}
              </span>
            </span>
          </p>
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
            <p style={{margin: 0}}>
              <b>ул.</b>
            </p>
            <p style={{margin: 0, flex: 0.35, borderBottom: '1px solid black', paddingLeft: '5px', fontSize: '28px'}}>
              {props.data.street}
            </p>
            <p style={{margin: 0}}>
              <b>д.</b>
            </p>
            <p style={{margin: 0, flex: 0.15, borderBottom: '1px solid black', paddingLeft: '5px', fontSize: '28px'}}>
              {props.data.house}
            </p>
            <p style={{margin: 0}}>
              <b>корп.</b>
            </p>
            <p
              style={{margin: 0, flex: 0.1, borderBottom: '1px solid black', paddingLeft: '5px', fontSize: '28px'}}
            ></p>
            <p style={{margin: 0}}>
              <b>кв.</b>
            </p>
            <p style={{margin: 0, flex: 0.15, borderBottom: '1px solid black', paddingLeft: '5px', fontSize: '28px'}}>
              {props.data.apartment}
            </p>
            <p style={{margin: 0}}>
              <b>комн.</b>
            </p>
            <p
              style={{margin: 0, flex: 0.1, borderBottom: '1px solid black', paddingLeft: '5px', fontSize: '28px'}}
            ></p>
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            width: '100%',
            marginTop: '5px',
          }}
        >
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '49%'}}>
            <p style={{margin: 0}}>
              <b>телефон потребителя:</b>
            </p>
            <p style={{margin: 0, flex: 0.9, borderBottom: '1px solid black', fontSize: '28px'}}>
              {props.data.customerPhone}
            </p>
          </div>
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '49%'}}>
            <p style={{margin: 0}}>
              <b>e-mail потребителя:</b>
            </p>
            <p style={{margin: 0, flex: 0.9, borderBottom: '1px solid black'}}>{props.data.email}</p>
          </div>
        </div>
        <p>
          Доступ представителей гарантирующего поставщика в помещение, в котором установлен (должен быть установлен /
          заменен / проверен) прибор учёта электрической энергии <b>не был обеспечен</b>.
        </p>
        <p style={{marginBottom: 0}}>
          В процедуре дополнительно принимали участие <i>(указать при участии)</i>:
        </p>
        <div style={{display: 'flex', flexDirection: 'column'}}>
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: '20px'}}>
            <p style={{margin: 0}}>
              <b>Представитель ООО «РКС-энерго»</b>
            </p>
            <div style={{width: '60%'}}>
              <span
                style={{
                  width: '100%',
                  borderBottom: '1px solid black',
                  display: 'inline-flex',
                  justifyContent: 'flex-end',
                }}
              >
                <p style={{margin: 0}}></p>
              </span>
              <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
                <div style={{display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'center'}}>
                  <p style={{margin: 0, fontSize: '22px'}}>
                    <i>(должность, ФИО)</i>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: '20px'}}>
            <div style={{display: 'flex', flexDirection: 'column'}}>
              <p style={{margin: 0, textWrap: 'balance'}}>
                <b>Представитель исполнителя коммунальных услуг</b>
              </p>
            </div>
            <div style={{width: '60%'}}>
              <span
                style={{
                  width: '100%',
                  borderBottom: '1px solid black',
                  display: 'inline-flex',
                  justifyContent: 'flex-end',
                }}
              >
                <p style={{margin: 0, letterSpacing: 2.5}}></p>
              </span>
              <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
                <div style={{display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'center'}}>
                  <p style={{margin: 0, fontSize: '22px'}}>
                    <i>(наименование организации, должность ФИО, телефон представителя)</i>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: '20px'}}>
          <p style={{margin: 0}}>
            <b>Потребитель (представитель)</b>
          </p>
          <div style={{width: '60%'}}>
            <span
              style={{
                width: '100%',
                borderBottom: '1px solid black',
                display: 'inline-flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                height: '18px',
              }}
            >
              <p style={{margin: 0, fontSize: '28px'}}></p>
            </span>
            <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
              <div style={{display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'center'}}>
                <p style={{margin: 0, fontSize: '22px'}}>
                  <i>(ФИО, телефон представителя)</i>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: '20px'}}>
          <p style={{margin: 0}}>
            <b>Иные лица</b>
          </p>
          <div style={{width: '60%', display: 'flex', flexDirection: 'column'}}>
            <div style={{width: '100%'}}>
              <span
                style={{
                  width: '100%',
                  borderBottom: '1px solid black',
                  display: 'inline-flex',
                  justifyContent: 'flex-end',
                  alignItems: 'flex-end',
                  height: '18px',
                }}
              >
                <p style={{margin: 0, fontSize: '20px'}}></p>
              </span>
              <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
                <div style={{display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'center'}}>
                  <p style={{margin: 0, fontSize: '22px'}}>
                    <i>(ФИО, телефон)</i>
                  </p>
                </div>
              </div>
            </div>
            <div style={{width: '100%'}}>
              <span
                style={{
                  width: '100%',
                  borderBottom: '1px solid black',
                  display: 'inline-flex',
                  justifyContent: 'flex-end',
                  alignItems: 'flex-end',
                  height: '18px',
                }}
              >
                <p style={{margin: 0, fontSize: '20px'}}></p>
              </span>
              <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
                <div style={{display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'center'}}>
                  <p style={{margin: 0, fontSize: '22px'}}>
                    <i>(ФИО, телефон)</i>
                  </p>
                </div>
              </div>
            </div>
            <div style={{width: '100%'}}>
              <span
                style={{
                  width: '100%',
                  borderBottom: '1px solid black',
                  display: 'inline-flex',
                  justifyContent: 'flex-end',
                  alignItems: 'flex-end',
                  height: '18px',
                }}
              >
                <p style={{margin: 0, fontSize: '20px'}}></p>
              </span>
              <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
                <div style={{display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'center'}}>
                  <p style={{margin: 0, fontSize: '22px'}}>
                    <i>(ФИО, телефон)</i>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style={{marginTop: '10px'}}>
          <span>
            <p style={{margin: 0, fontSize: '28px'}}>
              Потребитель (представитель)&nbsp;
              <input style={{height: '28px', width: '28px', margin: 0}} type="checkbox" />
              &nbsp;находился в помещении, но отказался пускать представителей гарантирующего поставщика к приборам
              учета. Потребитель (представитель) от подписания настоящего акта отказался&nbsp;
              <input style={{height: '28px', width: '28px', margin: 0}} type="checkbox" />
              &nbsp;, без указания причины&nbsp;
              <input style={{height: '28px', width: '28px', margin: 0}} type="checkbox" />
              &nbsp;/&nbsp;указав следующую причину&nbsp;
              <input style={{height: '28px', width: '28px', margin: 0}} type="checkbox" />
              &nbsp;
            </p>
          </span>
          <div style={{display: 'flex', flexDirection: 'column', fontSize: '28px'}}>
            <span>
              __________________________________________________________________________________________________________________________________
            </span>
            <span>
              __________________________________________________________________________________________________________________________________
            </span>
            <span>
              __________________________________________________________________________________________________________________________________
            </span>
            <span>
              __________________________________________________________________________________________________________________________________
            </span>
            <span>
              __________________________________________________________________________________________________________________________________
            </span>
          </div>
          <span>
            <p style={{margin: 0, fontSize: '28px'}}>
              Потребитель&nbsp;
              <input style={{height: '28px', width: '28px', margin: 0}} type="checkbox" />
              &nbsp;отсутствовал в помещении.
            </p>
          </span>
        </div>
        <div style={{display: 'flex', flexDirection: 'column'}}>
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: '20px'}}>
            <p style={{margin: 0}}>
              <b>Представитель ООО «РКС-энерго»</b>
            </p>
            <div style={{width: '60%', display: 'flex', flexDirection: 'column'}}>
              <div style={{width: '100%'}}>
                <span
                  style={{
                    width: '100%',
                    borderBottom: '1px solid black',
                    display: 'inline-flex',
                    justifyContent: 'flex-end',
                  }}
                >
                  <p style={{margin: 0}}>
                    <b>
                      (&nbsp;&nbsp;
                      {props.data.userFio
                        .split(' ')
                        .map((i: any, index: any) => (index !== 0 ? i[0] + '.' : i))
                        .join(' ')}
                      &nbsp;&nbsp;)
                    </b>
                  </p>
                </span>
                <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
                  <div style={{display: 'flex', flexDirection: 'row', width: '50%', justifyContent: 'center'}}>
                    <p style={{margin: 0, fontSize: '22px'}}>
                      <i>(подпись)</i>
                    </p>
                  </div>
                  <div style={{display: 'flex', flexDirection: 'row', width: '50%', justifyContent: 'center'}}>
                    <p style={{margin: 0, fontSize: '22px'}}>
                      <i>(расшифровка подписи, ФИО)</i>
                    </p>
                  </div>
                </div>
              </div>
              <div style={{width: '100%'}}>
                <span
                  style={{
                    width: '100%',
                    borderBottom: '1px solid black',
                    display: 'inline-flex',
                    justifyContent: 'flex-end',
                  }}
                >
                  <p style={{margin: 0, marginTop: '10px'}}></p>
                </span>
                <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
                  <div style={{display: 'flex', flexDirection: 'row', width: '50%', justifyContent: 'center'}}>
                    <p style={{margin: 0, fontSize: '22px'}}>
                      <i>(подпись)</i>
                    </p>
                  </div>
                  <div style={{display: 'flex', flexDirection: 'row', width: '50%', justifyContent: 'center'}}>
                    <p style={{margin: 0, fontSize: '22px'}}>
                      <i>(расшифровка подписи, ФИО)</i>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
            <div style={{display: 'flex', flexDirection: 'column'}}>
              <p style={{margin: 0, textWrap: 'balance'}}>
                <b>Представитель исполнителя коммунальных услуг</b>
              </p>
              <div style={{display: 'flex', flexDirection: 'row'}}>
                <p style={{margin: 0, fontSize: '22px'}}>
                  <i>(при участии)</i>
                </p>
              </div>
            </div>
            <div style={{width: '60%'}}>
              <span
                style={{
                  width: '100%',
                  borderBottom: '1px solid black',
                  display: 'inline-flex',
                  justifyContent: 'flex-end',
                }}
              >
                <p style={{margin: 0, letterSpacing: 2.5}}>
                  <b>
                    (&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;)
                  </b>
                </p>
              </span>
              <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
                <div style={{display: 'flex', flexDirection: 'row', width: '50%', justifyContent: 'center'}}>
                  <p style={{margin: 0, fontSize: '22px'}}>
                    <i>(подпись)</i>
                  </p>
                </div>
                <div style={{display: 'flex', flexDirection: 'row', width: '50%', justifyContent: 'center'}}>
                  <p style={{margin: 0, fontSize: '22px'}}>
                    <i>(расшифровка подписи, ФИО)</i>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
          <div style={{display: 'flex', flexDirection: 'column'}}>
            <p style={{margin: 0}}>
              <b>Потребитель (представитель)</b>
            </p>
            <div style={{display: 'flex', flexDirection: 'row'}}>
              <p style={{margin: 0, fontSize: '22px'}}>
                <i>(при участии)</i>
              </p>
            </div>
          </div>
          <div style={{width: '60%'}}>
            <span
              style={{
                width: '100%',
                borderBottom: '1px solid black',
                display: 'inline-flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                height: '18px',
              }}
            >
              <p style={{margin: 0, fontSize: '28px'}}>
                <b>(&nbsp;{props.data.customer}&nbsp;)</b>
              </p>
            </span>
            <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
              <div style={{display: 'flex', flexDirection: 'row', width: '50%', justifyContent: 'center'}}>
                <p style={{margin: 0, fontSize: '22px'}}>
                  <i>(подпись)</i>
                </p>
              </div>
              <div style={{display: 'flex', flexDirection: 'row', width: '50%', justifyContent: 'center'}}>
                <p style={{margin: 0, fontSize: '22px'}}>
                  <i>(расшифровка подписи, ФИО)</i>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
          <div style={{display: 'flex', flexDirection: 'column'}}>
            <p style={{margin: 0}}>
              <b>Иные лица</b>
            </p>
            <div style={{display: 'flex', flexDirection: 'row'}}>
              <p style={{margin: 0, fontSize: '22px'}}>
                <i>(при участии)</i>
              </p>
            </div>
          </div>
          <div style={{width: '60%', display: 'flex', flexDirection: 'column'}}>
            <div style={{width: '100%'}}>
              <span
                style={{
                  width: '100%',
                  borderBottom: '1px solid black',
                  display: 'inline-flex',
                  justifyContent: 'flex-end',
                }}
              >
                <p style={{margin: 0, letterSpacing: 2.5}}>
                  <b>
                    (&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;)
                  </b>
                </p>
              </span>
              <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
                <div style={{display: 'flex', flexDirection: 'row', width: '50%', justifyContent: 'center'}}>
                  <p style={{margin: 0, fontSize: '22px'}}>
                    <i>(подпись)</i>
                  </p>
                </div>
                <div style={{display: 'flex', flexDirection: 'row', width: '50%', justifyContent: 'center'}}>
                  <p style={{margin: 0, fontSize: '22px'}}>
                    <i>(расшифровка подписи, ФИО)</i>
                  </p>
                </div>
              </div>
            </div>
            <div style={{width: '100%'}}>
              <span
                style={{
                  width: '100%',
                  borderBottom: '1px solid black',
                  display: 'inline-flex',
                  justifyContent: 'flex-end',
                }}
              >
                <p style={{margin: 0, letterSpacing: 2.5}}>
                  <b>
                    (&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;)
                  </b>
                </p>
              </span>
              <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
                <div style={{display: 'flex', flexDirection: 'row', width: '50%', justifyContent: 'center'}}>
                  <p style={{margin: 0, fontSize: '22px'}}>
                    <i>(подпись)</i>
                  </p>
                </div>
                <div style={{display: 'flex', flexDirection: 'row', width: '50%', justifyContent: 'center'}}>
                  <p style={{margin: 0, fontSize: '22px'}}>
                    <i>(расшифровка подписи, ФИО)</i>
                  </p>
                </div>
              </div>
            </div>
            <div style={{width: '100%'}}>
              <span
                style={{
                  width: '100%',
                  borderBottom: '1px solid black',
                  display: 'inline-flex',
                  justifyContent: 'flex-end',
                }}
              >
                <p style={{margin: 0, letterSpacing: 2.5}}>
                  <b>
                    (&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;)
                  </b>
                </p>
              </span>
              <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
                <div style={{display: 'flex', flexDirection: 'row', width: '50%', justifyContent: 'center'}}>
                  <p style={{margin: 0, fontSize: '22px'}}>
                    <i>(подпись)</i>
                  </p>
                </div>
                <div style={{display: 'flex', flexDirection: 'row', width: '50%', justifyContent: 'center'}}>
                  <p style={{margin: 0, fontSize: '22px'}}>
                    <i>(расшифровка подписи, ФИО)</i>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={{width: '100%', height: 'fit-content', padding: '20px 40px'}}>
        <div style={{display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'center'}}>
          <span style={{fontSize: '28px', marginBottom: '20px'}}>Уважаемый потребитель!</span>
        </div>
        <div style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
          <p style={{fontSize: '28px', textIndent: '30px', margin: 0, textAlign: 'justify'}}>
            Гарантирующий поставщик ООО «РКС-энерго» информирует, что в соответствии с со статьей 37 Федерального закона
            «Об электроэнергетике» от 26.03.2003 № 35-ФЗ обязанность по установке (замене) прибора учета электрической
            энергии в многоквартирных домах возложена на гарантирующих поставщиков.
          </p>
          <p style={{fontSize: '28px', textIndent: '30px', margin: 0, textAlign: 'justify'}}>
            Уведомляем Вас, что в отношении Вашего электроснабжаемого объекта запланированы работы по установке/ замене
            индивидуального прибора учета электрической энергии на безвозмездной основе за счет средств гарантирующего
            поставщика.
          </p>
          <p style={{fontSize: '28px', textIndent: '30px', margin: 0, textAlign: 'justify'}}>
            Уполномоченным представителем гарантирующего поставщика для проведения работ по установке/ замене приборов
            учета является ООО «ЭМС» на основании доверенности №147-1/2024 от 16.05.2024г.
          </p>
          <p style={{fontSize: '28px', textIndent: '30px', margin: 0, textAlign: 'justify'}}>
            Представители гарантирующего поставщика на руках имеют доверенность на право проведения соответствующих
            работ и по Вашему требованию обязаны ее предъявить.
          </p>
          <p style={{fontSize: '28px', textIndent: '30px', margin: 0, textAlign: 'justify'}}>
            На текущий момент, в связи с необеспечением доступа к месту установки прибора учета, вышеуказанные работы не
            могут быть произведены.{' '}
          </p>
          <p style={{fontSize: '28px', textIndent: '30px', margin: 0, textAlign: 'justify'}}>
            Просим для согласования даты и времени проведения работ связаться с нами по контактному тел. 8 (977)
            717-01-36 и (или) эл. почте ems@eiservis.ru и предоставить доступ в назначенные сроки.
          </p>
          <p style={{fontSize: '28px', textIndent: '30px', margin: 0, textAlign: 'justify'}}>
            Сообщаем, что, на основании постановления Правительства РФ от 06.05.2011 №354:
          </p>
          <ul style={{fontSize: '28px', textAlign: 'justify'}}>
            <li>
              потребитель обязан допускать представителей гарантирующего поставщика в занимаемое помещение для
              установки, ввода в эксплуатацию приборов учета электрической энергии,
            </li>
            <li>
              в случае двукратного недопуска плата за коммунальную услугу по электроснабжению будет рассчитываться
              исходя из нормативов потребления коммунальных услуг с применением к стоимости повышающего коэффициента
              1,5.
            </li>
          </ul>
        </div>
        <div style={{display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'flex-end'}}>
          <div
            style={{display: 'flex', flexDirection: 'column', width: '100%', alignItems: 'flex-end', marginTop: '15px'}}
          >
            <span style={{fontSize: '28px', margin: 0}}>С уважением,</span>
            <span style={{fontSize: '28px', margin: 0}}>гарантирующий поставщик ООО «РКС-энерго»</span>
          </div>
        </div>
      </div>
    </div>
  );
};
